import React from 'react'
import { useStoreView } from 'hooks/useStoreView'
import { MENU_ITEMS } from 'app/sofia/resources/constants'
import { MENU_ITEMS as LIV_MENU_ITEMS } from 'app/livbrite/resources/constants'
import { MenuItem } from '../../../MenuItem'
import { Wrapper } from './components/Styled'

export const MainMenu = () => {
  const { isSofiaAndGrace } = useStoreView()
  const MenuItems = isSofiaAndGrace ? MENU_ITEMS : LIV_MENU_ITEMS

  return (
    <Wrapper>
      <ul>
        {MenuItems.map(menuItem => {
          return (
            <MenuItem
              key={menuItem.label}
              label={menuItem.label}
              block={menuItem.block}
            />
          )
        })}
      </ul>
    </Wrapper>
  )
}
